/* eslint-disable no-console */
import config from '../config';

export default class ThermalWebSocketService {
  socket;

  state = { data: [] };

  setState = () => {};

  constructor() {
    this.socket = null;
  }

  connect() {
    return new Promise((resolve, reject) => {
      this.socket = new WebSocket(config.thermalWssUrl);

      this.socket.onopen = () => {
        this.socket.send(JSON.stringify({
          action: '$connect',
          password: config.thermalWssUrlPassword,
        }));
        resolve();
      };

      this.socket.onerror = (err) => {
        console.error('⚠️ WebSocket error:', err);
        reject(err);
      };

      this.socket.onclose = () => {
        console.log('❌ WebSocket disconnected');
      };

      this.socket.onmessage = (event) => {
        let parsed;

        try {
          parsed = JSON.parse(event.data);
        } catch {
          parsed = { raw: event.data };
        }

        this.state.data = [...this.state.data, parsed];
        this.setState({ ...this.state });

        if (typeof this.onMessageCallback === 'function') {
          this.onMessageCallback(parsed);
        }
      };
    });
  }

  onMessage(callback) {
    this.onMessageCallback = callback;
  }

  send(data) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    } else {
      console.warn('⚠️ Tried to send message, but socket is not open');
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
    }
  }
}
